<template lang="pug">
  footer.footer.footer--hide(v-if="footer")
      .footer__content
          .footer__copyright {{footer.copyright}}
          router-link.footer__link(:to="footer.link.href" target="_blank") {{ footer.link.title }}

</template>

<script>
  import '@/components/common/footer/footer.styl';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import EventBus from '@/eventBus';

  export default {
    name: 'Footer',

    data() {
      return {
        // footer: null
      }
    },

    props: ['footer'],

    components: {
      SvgIcon,
    },

    created() {
      // EventBus.$on('pageLoaded', res => {
      //     if(!this.footer) {
      //         console.log('here', (res.footer));
      //         this.footer = res.footer;
      //     }
      // })
    },

  }
</script>
